<template>
  <VueSlickCarousel
    v-bind="settings"
    v-if="
      colors.productContentItem &&
        colors.productContentItem.productStyleImages.length > 0
    "
  >
    <template #nextArrow>
      <button type="button" class="custom-arrow-next">
        <span class="png-icon png-icon-icons-glyph--k-chevron-right"></span>
      </button>
    </template>
    <template #prevArrow>
      <button type="button" class="custom-arrow-prev">
        <span class="png-icon png-icon-icons-glyph--k-chevron-left"></span>
      </button>
    </template>
    <div
      v-for="color in colors.productContentItem.productStyleImages"
      :key="color.colorNumber"
    >
      <img
        class="slick-img-fluid"
        @click="previewModal(color, colors)"
        :src="color.imageLink"
        alt="img"
      />
    </div>
  </VueSlickCarousel>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
  props: ["colors"],
  data() {
    return {
      settings: {
        centerMode: false,
        centerPadding: "5px",
        infinite: false,
        speed: 500,
        slidesToShow: this.colors.size == 0 ? 3 : 5,
        adaptiveHeight: true,
        variableWidth: true
      }
    };
  },
  components: {
    VueSlickCarousel
  },

  methods: {
    previewModal(item, colors) {
      this.$emit("colorPreview", { item: item, colors: colors });
    }
  }
};
</script>
